import React from 'react';
import { useTranslation } from 'react-i18next';

function ArrowIcon() {
  return (
    <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5} aria-hidden="true">
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14m-5-5 5 5-5 5" />
    </svg>
  );
}

function SkillPathArtwork() {
  return (
    <div className="relative grid h-32 w-36 shrink-0 place-items-center" aria-hidden="true">
      <div className="absolute inset-2 rounded-full bg-sky-100 blur-sm" />
      <svg className="relative h-28 w-32 drop-shadow-xl" viewBox="0 0 150 130" fill="none">
        <defs>
          <linearGradient id="stepTop" x1="0" y1="0" x2="1" y2="1">
            <stop stopColor="#60a5fa" />
            <stop offset="1" stopColor="#2563eb" />
          </linearGradient>
          <linearGradient id="stepSide" x1="0" y1="0" x2="0" y2="1">
            <stop stopColor="#2563eb" />
            <stop offset="1" stopColor="#0f65ce" />
          </linearGradient>
        </defs>
        <path d="M21 96 49 82l24 12-28 14-24-12Z" fill="url(#stepTop)" />
        <path d="M21 96v21l24 12v-21L21 96Z" fill="#1682e8" />
        <path d="m45 108 28-14v21l-28 14v-21Z" fill="url(#stepSide)" />
        <path d="m49 72 28-14 24 12-28 14-24-12Z" fill="url(#stepTop)" />
        <path d="M49 72v22l24 12V84L49 72Z" fill="#1682e8" />
        <path d="m73 84 28-14v22l-28 14V84Z" fill="url(#stepSide)" />
        <path d="m77 48 28-14 24 12-28 14-24-12Z" fill="url(#stepTop)" />
        <path d="M77 48v22l24 12V60L77 48Z" fill="#1682e8" />
        <path d="m101 60 28-14v22l-28 14V60Z" fill="url(#stepSide)" />
        <path d="M108 36V8" stroke="#075fc5" strokeWidth="4" strokeLinecap="round" />
        <path d="M110 9c13 0 15 8 27 5v17c-12 3-15-5-27-5V9Z" fill="#0ea5e9" />
        <circle cx="108" cy="7" r="4" fill="#38bdf8" />
      </svg>
      <span className="absolute left-1 top-5 text-lg text-sky-400">✦</span>
      <span className="absolute right-0 top-1 text-sm text-sky-300">✦</span>
    </div>
  );
}

function TopicBookArtwork() {
  return (
    <div className="relative grid h-32 w-36 shrink-0 place-items-center" aria-hidden="true">
      <div className="absolute inset-2 rounded-full bg-violet-100 blur-sm" />
      <svg className="relative h-28 w-28 rotate-6 drop-shadow-xl" viewBox="0 0 120 130" fill="none">
        <defs>
          <linearGradient id="bookCover" x1="0" y1="0" x2="1" y2="1">
            <stop stopColor="#a78bfa" />
            <stop offset="1" stopColor="#6d28d9" />
          </linearGradient>
        </defs>
        <path d="M33 9 94 29c7 2 11 9 9 16l-20 72-62-22L33 9Z" fill="#4c1d95" />
        <path d="M27 7 89 27c7 2 11 9 9 16l-19 69-61-21L27 7Z" fill="url(#bookCover)" stroke="#7c3aed" strokeWidth="3" />
        <path d="m36 11 53 18c5 2 8 6 8 11L77 105 25 87 36 11Z" stroke="#c4b5fd" strokeWidth="3" />
        <path d="m58 42 5 14 15 2-12 9 3 15-12-8-13 8 4-15-11-9 15-2 6-14Z" fill="#ede9fe" />
        <path d="M79 112 18 91l5 13 54 19 6-6-4-5Z" fill="#ddd6fe" />
      </svg>
      <span className="absolute left-1 top-6 text-lg text-violet-400">✦</span>
      <span className="absolute right-1 top-2 text-sm text-violet-300">✦</span>
    </div>
  );
}

function DailyTestsArtwork() {
  return (
    <div className="relative grid h-28 w-32 shrink-0 place-items-center" aria-hidden="true">
      <div className="absolute inset-2 rounded-full bg-amber-100 blur-sm" />
      <svg className="relative h-24 w-28 -rotate-3 drop-shadow-xl" viewBox="0 0 120 110" fill="none">
        <defs>
          <linearGradient id="testPaper" x1="0" y1="0" x2="1" y2="1">
            <stop stopColor="#fff7ed" />
            <stop offset="1" stopColor="#ffedd5" />
          </linearGradient>
          <linearGradient id="testBadge" x1="0" y1="0" x2="1" y2="1">
            <stop stopColor="#fb923c" />
            <stop offset="1" stopColor="#ea580c" />
          </linearGradient>
        </defs>
        <rect x="23" y="13" width="73" height="87" rx="10" fill="#c2410c" opacity=".22" />
        <rect x="17" y="8" width="73" height="87" rx="10" fill="url(#testPaper)" stroke="#fb923c" strokeWidth="3" />
        <rect x="35" y="2" width="37" height="15" rx="7" fill="url(#testBadge)" />
        <path d="m31 36 5 5 9-11M31 58l5 5 9-11M31 80l5 5 9-11" stroke="#f97316" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M53 36h23M53 58h23M53 80h17" stroke="#fdba74" strokeWidth="5" strokeLinecap="round" />
        <circle cx="91" cy="84" r="21" fill="url(#testBadge)" />
        <path d="m81 84 7 7 13-16" stroke="white" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      <span className="absolute left-0 top-4 text-lg text-amber-400">✦</span>
      <span className="absolute right-0 top-0 text-sm text-orange-300">✦</span>
    </div>
  );
}

function StatPill({ icon, children, tone }) {
  const classes = tone === 'purple'
    ? 'border-violet-100 bg-violet-50/80 text-violet-700'
    : tone === 'orange'
      ? 'border-orange-100 bg-orange-50/80 text-orange-700'
      : 'border-sky-100 bg-sky-50/80 text-blue-700';
  return (
    <span className={`inline-flex min-h-10 items-center justify-center gap-2 rounded-xl border px-3 py-2 text-xs font-bold ${classes}`}>
      <span aria-hidden="true">{icon}</span>
      {children}
    </span>
  );
}

function DailyTestsPreview({ tests, status }) {
  const { t } = useTranslation();

  if (status === 'loading') {
    return (
      <div className="space-y-2" aria-label={t('learningPaths.loadingTests')}>
        {[1, 2, 3].map((item) => <div key={item} className="h-12 animate-pulse rounded-xl bg-orange-100/70" />)}
      </div>
    );
  }

  if (status !== 'ready') {
    return (
      <div className="grid min-h-[10rem] place-items-center rounded-2xl border border-dashed border-orange-200 bg-orange-50/60 px-6 text-center">
        <div>
          <span className="text-3xl" aria-hidden="true">🧪</span>
          <p className="mt-2 text-sm font-black text-orange-900">{t('learningPaths.testsComingSoon')}</p>
          <p className="mt-1 text-xs leading-relaxed text-orange-700">{t('learningPaths.testsComingSoonDesc')}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-2xl border border-orange-100 bg-white/85">
      {tests.slice(0, 3).map((test, index) => (
        <div key={test.id} className="flex min-h-12 items-center gap-3 border-b border-orange-50 px-3 py-2.5 last:border-0">
          <span className="grid h-7 w-7 shrink-0 place-items-center rounded-lg bg-orange-100 text-[10px] font-black text-orange-700">
            {test.day}
          </span>
          <span className="min-w-0 flex-1">
            <span className="block truncate text-xs font-black text-slate-700">{test.theme}</span>
            {test.focus && <span className="block truncate text-[10px] text-slate-500">{test.focus}</span>}
          </span>
          {index === 0 && <span className="shrink-0 text-[10px] font-black text-emerald-600">{t('learningPaths.ready')}</span>}
        </div>
      ))}
    </div>
  );
}

function TopicPreview({ chapters, status }) {
  const { t } = useTranslation();

  if (status === 'loading') {
    return (
      <div className="space-y-2" aria-label={t('learningPaths.loadingTopics')}>
        {[1, 2, 3, 4].map((item) => <div key={item} className="h-11 animate-pulse rounded-xl bg-violet-100/70" />)}
      </div>
    );
  }

  if (status !== 'ready') {
    return (
      <div className="grid min-h-[12.25rem] place-items-center rounded-2xl border border-dashed border-violet-200 bg-violet-50/60 px-6 text-center">
        <div>
          <span className="text-3xl" aria-hidden="true">🪄</span>
          <p className="mt-2 text-sm font-black text-violet-900">{t('learningPaths.topicsComingSoon')}</p>
          <p className="mt-1 text-xs leading-relaxed text-violet-600">{t('learningPaths.topicsComingSoonDesc')}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white/80">
      {chapters.slice(0, 4).map((chapter, index) => (
        <div key={chapter.id} className="flex min-h-11 items-center gap-3 border-b border-slate-100 px-3 py-2.5 last:border-0">
          <span className="grid h-6 w-6 shrink-0 place-items-center rounded-lg bg-violet-100 text-[10px] font-black text-violet-700">
            {chapter.chapterNumber}
          </span>
          <span className="min-w-0 flex-1 truncate text-xs font-semibold text-slate-700">{chapter.label}</span>
          {index === 0 && <span className="shrink-0 text-[10px] font-black text-emerald-600">{t('learningPaths.ready')}</span>}
        </div>
      ))}
    </div>
  );
}

export default function LearningPathChooser({
  targetLanguageLabel,
  level,
  skillSteps = [],
  topicChapters = [],
  topicStatus = 'loading',
  dailyTests = [],
  dailyTestsStatus = 'loading',
  onStartSkill,
  onExploreTopics,
  onPreviewSkill,
  onPreviewTopics,
  onStartDailyTests,
}) {
  const { t } = useTranslation();
  const normalizedLevel = String(level || 'a1').toUpperCase();
  const remainingTopics = Math.max(0, topicChapters.length - 4);
  const topicsReady = topicStatus === 'ready' && topicChapters.length > 0;
  const dailyTestsReady = dailyTestsStatus === 'ready' && dailyTests.length > 0;
  const questionsPerTest = dailyTests.find((test) => test.questionCount > 0)?.questionCount || 0;

  return (
    <section className="relative overflow-hidden border-b border-slate-200/70 bg-white/65">
      <div className="pointer-events-none absolute -left-32 top-8 h-72 w-72 rounded-full bg-sky-200/45 blur-3xl" />
      <div className="pointer-events-none absolute -right-24 top-12 h-80 w-80 rounded-full bg-violet-200/50 blur-3xl" />

      <div className="relative mx-auto max-w-6xl px-4 py-10 sm:px-6 sm:py-12 lg:px-8">
        <div className="text-center">
          <h1 className="text-3xl font-black text-slate-950 sm:text-4xl">
            {t('learningPaths.titlePrefix')}{' '}
            <span className="bg-gradient-to-r from-indigo-600 to-violet-600 bg-clip-text text-transparent">
              {targetLanguageLabel}?
            </span>
          </h1>
          <p className="mt-2 text-sm text-slate-600 sm:text-base">{t('learningPaths.subtitle')}</p>
          <div className="mx-auto mt-4 inline-flex max-w-full items-center gap-2 rounded-full border border-emerald-200 bg-emerald-50 px-4 py-2 text-xs font-bold text-emerald-700 sm:text-sm">
            <span className="text-base" aria-hidden="true">⇄</span>
            <span>{t('learningPaths.sameLevel', { level: normalizedLevel })}</span>
          </div>
        </div>

        <div className="mt-7 grid gap-5 lg:grid-cols-2">
          <article className="flex h-full flex-col rounded-3xl border border-sky-200 bg-gradient-to-br from-white via-sky-50/40 to-blue-50/70 p-5 shadow-lg shadow-sky-100/70 sm:p-6">
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0 pt-1">
                <span className="inline-flex rounded-full bg-sky-100 px-3 py-1 text-[10px] font-black uppercase tracking-wider text-blue-700">
                  {t('learningPaths.option', { number: 1 })}
                </span>
                <h2 className="mt-3 text-3xl font-black text-blue-700">{t('learningPaths.skillTitle')}</h2>
                <p className="mt-2 max-w-xs text-sm leading-relaxed text-slate-600">{t('learningPaths.skillDesc')}</p>
              </div>
              <SkillPathArtwork />
            </div>

            <div className="mt-4 grid grid-cols-2 gap-2 sm:grid-cols-4">
              {skillSteps.map((step) => (
                <span key={step.code} className="flex min-h-11 items-center gap-2 rounded-xl border border-sky-100 bg-white/90 px-2.5 py-2 text-[11px] font-bold text-blue-700">
                  <span className="text-base" aria-hidden="true">{step.icon}</span>
                  <span className="truncate">{t(`learningPaths.compactSteps.${step.code}`, { defaultValue: step.label })}</span>
                </span>
              ))}
            </div>

            <div className="mt-auto grid grid-cols-3 gap-2 pt-5">
              <StatPill icon="☷">{t('learningPaths.stepCount', { count: skillSteps.length })}</StatPill>
              <StatPill icon="🧩">{t('learningPaths.structured')}</StatPill>
              <StatPill icon="▥">{t('learningPaths.tracking')}</StatPill>
            </div>

            <button
              type="button"
              onClick={onStartSkill}
              disabled={skillSteps.length === 0}
              className="mt-4 inline-flex w-full items-center justify-center gap-3 rounded-xl bg-gradient-to-r from-blue-600 to-sky-600 px-5 py-3 text-sm font-black text-white shadow-lg shadow-blue-200 transition hover:-translate-y-0.5 hover:from-blue-700 hover:to-sky-700 disabled:cursor-not-allowed disabled:opacity-50"
            >
              {t('learningPaths.startSkill')}
              <ArrowIcon />
            </button>
            <button type="button" onClick={onPreviewSkill} className="mt-3 text-xs font-black text-blue-700 hover:text-blue-900">
              {t('learningPaths.previewSkill')}
            </button>
          </article>

          <article className="flex h-full flex-col rounded-3xl border border-violet-200 bg-gradient-to-br from-white via-violet-50/35 to-purple-50/70 p-5 shadow-lg shadow-violet-100/70 sm:p-6">
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0 pt-1">
                <span className="inline-flex rounded-full bg-violet-100 px-3 py-1 text-[10px] font-black uppercase tracking-wider text-violet-700">
                  {t('learningPaths.option', { number: 2 })}
                </span>
                <h2 className="mt-3 text-3xl font-black text-violet-700">{t('learningPaths.topicTitle')}</h2>
                <p className="mt-2 max-w-xs text-sm leading-relaxed text-slate-600">{t('learningPaths.topicDesc')}</p>
              </div>
              <TopicBookArtwork />
            </div>

            <div className="mt-4">
              <TopicPreview chapters={topicChapters} status={topicStatus} />
              {topicsReady && remainingTopics > 0 && (
                <p className="mt-2 px-2 text-xs font-black text-violet-700">
                  {t('learningPaths.moreChapters', { count: remainingTopics })}
                </p>
              )}
            </div>

            <div className="mt-auto grid grid-cols-3 gap-2 pt-4">
              <StatPill tone="purple" icon="▤">{t('learningPaths.lessonCount', { count: topicChapters.length })}</StatPill>
              <StatPill tone="purple" icon="♧">{t('learningPaths.realTopics')}</StatPill>
              <StatPill tone="purple" icon="◷">{t('learningPaths.ownPace')}</StatPill>
            </div>

            <button
              type="button"
              onClick={onExploreTopics}
              disabled={!topicsReady}
              className="mt-4 inline-flex w-full items-center justify-center gap-3 rounded-xl bg-gradient-to-r from-violet-600 to-purple-600 px-5 py-3 text-sm font-black text-white shadow-lg shadow-violet-200 transition hover:-translate-y-0.5 hover:from-violet-700 hover:to-purple-700 disabled:cursor-not-allowed disabled:opacity-50"
            >
              {topicsReady ? t('learningPaths.exploreTopics') : t('learningPaths.topicUnavailable')}
              {topicsReady && <ArrowIcon />}
            </button>
            <button
              type="button"
              onClick={onPreviewTopics}
              disabled={!topicsReady}
              className="mt-3 text-xs font-black text-violet-700 hover:text-violet-900 disabled:cursor-not-allowed disabled:text-slate-400"
            >
              {t('learningPaths.previewTopics')}
            </button>
          </article>

          <article className="flex h-full flex-col rounded-3xl border border-orange-200 bg-gradient-to-br from-white via-amber-50/45 to-orange-50/80 p-5 shadow-lg shadow-orange-100/70 sm:p-6 lg:col-span-2">
            <div className="grid gap-5 lg:grid-cols-[1fr_1.05fr] lg:items-center">
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0 pt-1">
                  <span className="inline-flex rounded-full bg-orange-100 px-3 py-1 text-[10px] font-black uppercase tracking-wider text-orange-700">
                    {t('learningPaths.option', { number: 3 })}
                  </span>
                  <h2 className="mt-3 text-3xl font-black text-orange-700">{t('learningPaths.testsTitle')}</h2>
                  <p className="mt-2 max-w-md text-sm leading-relaxed text-slate-600">{t('learningPaths.testsDesc')}</p>
                </div>
                <DailyTestsArtwork />
              </div>

              <DailyTestsPreview tests={dailyTests} status={dailyTestsStatus} />
            </div>

            <div className="mt-5 grid gap-3 sm:grid-cols-3 lg:grid-cols-[1fr_1fr_1fr_1.55fr]">
              <StatPill tone="orange" icon="▤">{t('learningPaths.testCount', { count: dailyTests.length })}</StatPill>
              <StatPill tone="orange" icon="☑">{t('learningPaths.questionCount', { count: questionsPerTest })}</StatPill>
              <StatPill tone="orange" icon="✦">{t('learningPaths.mixedSkills')}</StatPill>
              <button
                type="button"
                onClick={onStartDailyTests}
                disabled={!dailyTestsReady}
                className="inline-flex min-h-10 w-full items-center justify-center gap-3 rounded-xl bg-gradient-to-r from-orange-500 to-amber-500 px-5 py-2.5 text-sm font-black text-white shadow-lg shadow-orange-200 transition hover:-translate-y-0.5 hover:from-orange-600 hover:to-amber-600 disabled:cursor-not-allowed disabled:opacity-50"
              >
                {dailyTestsReady ? t('learningPaths.startTests') : t('learningPaths.testsUnavailable')}
                {dailyTestsReady && <ArrowIcon />}
              </button>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}
